import type { PaywallType } from "@product/rosetta-sdk";
import { Paywall } from "@product/rosetta-sdk";
import { useAtomValue } from "jotai";
import { useCallback } from "react";

import { rosettaAtom } from "scmp-app/lib/rosetta";

type ArticleContext = {
  flag?: string;
  paywallType?: PaywallType;
  topicIds?: string[];
};

export const usePaywallStrategies = () => {
  const asyncRosettaState = useAtomValue(rosettaAtom);

  const getActivePaywallStrategy = useCallback(
    (articleContext: ArticleContext) => {
      if (typeof window === "undefined" || !asyncRosettaState?.result?.instance) {
        return null;
      }

      const paywallStrategies =
        asyncRosettaState?.result.instance?.getRosettaAppConfig()?.paywall?.strategies ?? [];

      const userCurrency =
        asyncRosettaState?.result?.instance?.rulesEngine.getOutcome("guest.currency") ?? "HKD";

      const { flag, paywallType, topicIds } = articleContext;
      return Paywall.strategies.getApplicablePaywallStrategy({
        filterContext: {
          article: {
            flag,
            topicIds,
            ...(paywallType && { paywall: paywallType }), // TODO: Migrate "archive" wall from filter to setting instead
          },
          user: { currency: userCurrency, type: asyncRosettaState?.result?.user?.types?.scmp },
        },
        paywallStrategyConfigs: paywallStrategies,
      });
    },
    [asyncRosettaState],
  );

  return {
    getActivePaywallStrategy,
  };
};
